module.exports = __webpack_public_path__ + "static/media/Industriekessel_03.3d26006c.jpg";